<template>
    <div>
        <dv-full-screen-container class="bg">

            <div class="d-flex flex-row mb-3 justify-content-start align-items-center w-100"
                 style="height: 8%" @click="switchScreenFull">
                <dv-decoration-6 style="width:20%;height:60%;"/>
                <dv-decoration-11 class="dv-card-title h-100" style="width:60%;font-size: 2rem">
                    <dv-decoration-9 style="width:45px;height:45px;"></dv-decoration-9>&nbsp;
                    OEE全面设备效率查询看板&nbsp;&nbsp;{{ queryForm.machineCode }}&nbsp;
                    {{ formatShortDate(queryForm.start) }} {{ formatShortEndDate(queryForm.end) }}
                </dv-decoration-11>
                <dv-decoration-6 :reverse="true" style="width:20%;height:60%;"/>

            </div>

            <div class="row" style="height: 90%;margin: 5px 30px;">

                <div class="col-12 h-7">
                    <div class="row d-flex justify-content-around" style="height: 100%">
                        <div class="col-12 h-100 decorative-text">

                            <el-row>

                                <el-col :span="2">操作者</el-col>
                                <el-col :span="2">部门</el-col>
                                <el-col :span="2">项目编号</el-col>
                                <el-col :span="2">部件名称</el-col>
                                <el-col :span="2">工单编号</el-col>
                                <el-col :span="2">工序</el-col>
                                <!--                                <el-col :span="2">工位</el-col>-->
                                <el-col :span="3">开始时间</el-col>
                                <el-col :span="3">结束时间</el-col>
                                <el-col :span="2">设备编码</el-col>
                                <el-col :span="2">&nbsp;</el-col>

                            </el-row>
                            <el-row justify="center">
                                <el-col :span="2">
                                    <el-input
                                        v-model="queryForm.operator" placeholder="输入姓名"
                                        class="my-custom-input"
                                        style="width: 90%;"></el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-input v-model="queryForm.deptName" placeholder="输入部门名称"
                                              style="width: 90%;"></el-input>
                                </el-col>

                                <el-col :span="2">
                                    <el-input v-model="queryForm.projectCode" placeholder="输入项目编号"
                                              style="width: 90%;"></el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-input v-model="queryForm.tsdItemName" placeholder="输入部件名称"
                                              style="width: 90%;"></el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-input v-model="queryForm.orderCode" placeholder="输入工单编号"
                                              style="width: 90%;"></el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-input v-model="queryForm.prdPpOperationName" placeholder="输入工序"
                                              style="width: 90%;"></el-input>
                                </el-col>
                                <!--                                <el-col :span="2">-->
                                <!--                                    <el-input v-model="queryForm.actualMstLocationName" placeholder="输入工位"-->
                                <!--                                              style="width: 90%;"></el-input>-->
                                <!--                                </el-col>-->
                                <el-col :span="3">
                                    <el-date-picker v-model="queryForm.start" type="datetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="默认当日开始"
                                                    style="width: 90%;"></el-date-picker>
                                </el-col>
                                <el-col :span="3">
                                    <el-date-picker v-model="queryForm.end" type="datetime"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    placeholder="默认当日结束" default-time="23:59:59"
                                                    style="width: 90%;"></el-date-picker>
                                </el-col>

                                <el-col :span="2">
                                    <el-select v-model="queryForm.machineCode" filterable placeholder="设备编码"
                                               style="width: 90%;">
                                        <el-option
                                            v-for="item in machineCodeOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="4">
                                    <el-button-group>
                                        <el-button type="primary" icon="el-icon-search" class="my-custom-button"
                                                   title="查询" :disabled="disableButton"
                                                   @click="refreshChildComponent">查询
                                        </el-button>
                                        <el-button type="primary" icon="el-icon-arrow-left" class="my-custom-button"
                                                   title="返回"
                                                   @click="goBack">返回
                                        </el-button>
                                    </el-button-group>
                                    &nbsp;
                                    <el-switch
                                        v-model="autoRefreshSwitch" size="small" title="自动刷新"
                                        class="my-custom-switch">
                                    </el-switch>
                                </el-col>


                            </el-row>

                        </div>
                    </div>
                </div>

                <div class="col-12 h-45">
                    <div class="row d-flex justify-content-around" style="height: 100%;">
                        <div class="col-6 h-100" style="position: relative; padding: 0px 20px;">
                            <!-- 开关组件 -->
                            <el-switch v-model="switch1" title="渲染开关"
                                       style="position: absolute; top: 15px; right:35px; z-index: 9999;"></el-switch>
                            <OeeQueryDevice :query-form="queryForm"
                                            :auto-refresh-flag="autoRefreshFlag"
                                            :render-view-flag="switch1"></OeeQueryDevice>
                        </div>
                        <div class="col-3 h-100" style="position: relative; padding: 0px 20px;">
                            <!-- 开关组件 -->
                            <el-switch v-model="switch2" title="渲染开关"
                                       style="position: absolute; top: 15px; right:35px; z-index: 9999;"></el-switch>
                            <OeeQueryProgramStatus :queryForm="queryForm"
                                                   :auto-refresh-flag="autoRefreshFlag"
                                                   :render-view-flag="switch2"></OeeQueryProgramStatus>
                        </div>
                        <div class="col-3 h-100" style="position: relative; padding: 0px 20px;">
                            <!-- 开关组件 -->
                            <el-switch v-model="switch3" title="渲染开关"
                                       style="position: absolute; top: 15px; right:35px; z-index: 9999;"></el-switch>
                            <OeeQueryOperateMode :queryForm="queryForm"
                                                 :auto-refresh-flag="autoRefreshFlag"
                                                 :render-view-flag="switch3"></OeeQueryOperateMode>
                        </div>
                    </div>
                </div>

                <div class="col-12 h-45">

                    <div class="row d-flex justify-content-around" style="height: 96%;">
                        <div class="col-12 h-100" style="position: relative; padding: 0px 5px;">
                            <!-- 开关组件 -->
                            <el-switch v-model="switch4" title="渲染开关"
                                       style="position: absolute; top: 30px; right:35px; z-index: 9999;"></el-switch>
                            <OeeQuerySpindle :queryForm="queryForm"
                                             :auto-refresh-flag="autoRefreshFlag"
                                             :render-view-flag="switch4"
                                             @data-processed="handleDataProcessed"></OeeQuerySpindle>
                        </div>
                    </div>
                </div>

            </div>

        </dv-full-screen-container>
    </div>
</template>

<script>

import screenfull from 'screenfull'
import EmCommonApi from "@/mixin/em/common/api";
import moment from "moment";
import OeeQueryDevice from "@/components/echarts-part/tpm/oee/charts/OeeQueryDevice.vue";
import OeeQueryProgramStatus from "@/components/echarts-part/tpm/oee/charts/OeeQueryProgramStatus.vue";
import OeeQueryOperateMode from "@/components/echarts-part/tpm/oee/charts/OeeQueryOperateMode.vue";
import OeeQuerySpindle from "@/components/echarts-part/tpm/oee/charts/OeeQuerySpindle.vue";

export default {
    name: "OeeLayout",
    mixins: [EmCommonApi],
    components: {
        OeeQueryDevice,
        OeeQueryProgramStatus,
        OeeQueryOperateMode,
        OeeQuerySpindle
    },
    data() {
        return {
            autoRefreshFlag: false, // 初始化为 false，不刷新子组件
            disableButton: false, // 控制按钮禁用状态
            queryForm: {
                operator: null,         //操作者
                deptName: null,         //部门
                projectCode: null,      //项目编号
                tsdItemName: null,      //部件名称
                orderCode: null,        //工单编号
                prdPpOperationName: null,   //工序
                actualMstLocationName: null,//工位
                start: null,            //开始时间
                end: null,              //结束时间
                machineCode: null         //设备编码
            },
            machineCodeOptions: [],
            datetime: '',
            currentWorkshop: 0,
            wsEnable: [true, true, true, true],
            indicatorPosition: '',
            arrow: 'hover',
            workshopCodeIndex: 0,
            refresh: {
                everySecond: {},
                everyHour: {},
                atTwoClock: {}
            },
            vIfLazyLoad: false,
            pageLoad: true,
            equipmentStatus1: "esParts",
            equipmentStatus2: "esRotors",
            equipmentStatus3: "esCasing",
            queryDate: "",
            queryTypeParts: 1,
            queryTypeRotor: 2,
            queryTypeCasing: 3,
            oeeDailyCountId1: 'oeeDailyCountPart',
            oeeDailyCountId2: 'oeeDailyCountRotor',
            oeeDailyCountId3: 'oeeDailyCountCasing',
            oeeDeviceCountId1: 'oeeMonthlyDeviceCount',
            oeeDeviceCountId2: 'oeeDailyDeviceCount',
            queryTypeMonthly: 1,
            queryTypeDaily: 2,
            autoRefreshSwitch: false,///<======================= 直接赋值并不能使它自动查询，没有触发啊！！！！！
            switch1: true,
            switch2: true,
            switch3: true,
            switch4: true
        }
    },
    created() {
        if (!screenfull.isFullscreen) {
            screenfull.toggle()
        }
        this.getDeviceCodes(1);
    },
    mounted() {
        this.fnResize();
        window.addEventListener('resize', this.fnResize, false);
        //this.getSafetyDate()

        //this.intervals()
        //setTimeout(() => this.vIfLazyLoad = true, 2000);
        //this.subscribeChannels();//订阅

        //定时轮巡查询
        // this.fresh = this.autoRefreshSwitch ? setInterval(() => {
        //     console.log("this.queryForm = ")
        //     console.log(this.queryForm)
        //     this.refreshChildComponent();
        //     //window.addEventListener('resize', this.chart.resize, false)
        // }, 10000) : null;
    },
    watch: {
        autoRefreshSwitch: {
            handler(newVal) {
                clearInterval(this.fresh);
                this.fresh = newVal ? setInterval(() => {
                    this.refreshChildComponent();
                }, 20000) : null;
            },
            immediate: true // 在声明时立即执行监听函数
        }
    },
    beforeDestroy() {
        this.clearIntervals()
        window.removeEventListener('resize', this.fnResize, false)
        document.documentElement.style.fontSize = '16px';

        // 退出页面前，退出全屏
        if (screenfull.isFullscreen) {
            screenfull.exit();
        }

    },

    methods: {
        async refreshChildComponent() {
            //console.log("this.queryForm=")
            //console.log(this.queryForm)

            //判断必填的查询条件
            //判断设备编码必填
            if (this.queryForm.machineCode === null || this.queryForm.machineCode.trim() === "") {
                //this.$message.warning("查询条件【设备编码】必须填写");
                this.$notify({
                    title: '警告',
                    message: '查询条件【设备编码】必须填写！',
                    type: 'warning'
                });
                return;
            }
            // if (!this.machineCodes.includes(this.queryForm.machineCode)) {
            //     // 使用Array.includes()方法检查输入的machineCode是否在数组中
            //     this.$message.warning("查询的设备编码【" + this.queryForm.machineCode + "】不存在或不在OEE统计范围！");
            //     return;
            // }

            //判断时间组合条件的逻辑
            if (this.queryForm.start === null && this.queryForm.end !== null) {
                //this.$message.warning("查询条件【开始时间】必须填写");
                this.$notify({
                    title: '警告',
                    message: '您已经选择了查询【结束时间】，请指定查询【开始时间】！',
                    type: 'warning'
                });
                return;
            }
            //判断不能查询超过31天
            if (this.queryForm.start !== null && this.queryForm.end !== null) {
                const startDate = new Date(this.queryForm.start);
                const endDate = new Date(this.queryForm.end);
                //console.log(startDate)
                //console.log(endDate)
                const diff = (endDate - startDate) / (1000 * 60 * 60 * 24);
                const roundedDiff = Math.floor(diff);
                if (diff > 32) {
                    //this.$message.warning("查询【开始时间】和【结束时间】为【" + diff + "】天,请控制查询时间小于等于【7】天！");
                    const msg = "查询【开始时间】和【结束时间】间隔为【" + roundedDiff + "】天,请控制查询时间小于等于【31】天！";
                    this.$notify({
                        title: '警告',
                        message: msg,
                        type: 'warning'
                    });
                    return;
                }

                if (diff > 7 && this.switch4) {
                    this.$notify({
                        title: '警告',
                        message: '建议关闭主轴渲染，否则大范围查询可能会使浏览器失去响应！',
                        type: 'warning'
                    });
                }
            }

            this.disableButton = true;      // 禁用按钮
            this.autoRefreshFlag = true;    //!this.autoRefreshFlag; // 切换 autoRefreshFlag 的值来触发子组件刷新

            // 等待 1 秒，模拟刷新过程（其实没什么用）
            await new Promise((resolve) => setTimeout(resolve, 1000));

            //autoRefreshFlag = true 触发子组件watch，执行中...

            this.autoRefreshFlag = false;

        },
        getDeviceCodes: function (type) {
            //直接取设备编码数组
            //const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getDeviceCodesFromSysParam?type=`
            //取完整看板配置List
            const _api = `${this.$_emApiMixin_moduleBaseApi("tpmOeeReportTor")}/tpmOeeReportTor/getOeeDashboardConfig?type=`
                + type
            this.$_emApiMixin_get(_api, false).then(value => {
                //console.log(">>>>>>>>>>> 取OEE看板配置 >>>>>>>>>>>")
                //console.log(value)
                const tempArray = [];
                value.forEach(item => {
                    tempArray.push(item.deviceCode);
                });
                //重组为el-select的option数据源
                this.machineCodeOptions = tempArray.map(code => ({value: code, label: code}));

                const findDefault = value.find(item => item.groupEnabled === true);
                let deviceCode;
                // 检查是否找到了具有 groupEnabled 属性为 true 的对象（第三看板默认查询设备编码开关）
                if (findDefault) {
                    deviceCode = findDefault.deviceCode;

                    if (findDefault.defaultQueryDays === undefined) {
                        //如果没有配置，默认查1天，即当天
                        findDefault.defaultQueryDays = 1;
                    }
                    //前端控制一下，确保查询天数在1-7天之间
                    let offsetDays = Math.max(1, Math.min(findDefault.defaultQueryDays, 7));
                    //开始时间偏移查询天数，后端配置参数
                    this.queryForm.start = this.formatQueryDateTimeWithOffset(offsetDays, true);
                    //结束时间就是当前日期，偏移量为0
                    this.queryForm.end = this.formatQueryDateTimeWithOffset(0, false);

                    //如果设置了默认查询设备编码，那么初始化开启：“查询+自动刷新”
                    this.autoRefreshSwitch = true;
                    this.queryForm.machineCode = deviceCode;
                    this.refreshChildComponent();
                }
            })
        },
        formatQueryDateTimeWithOffset(offset, isStart) {
            const currentDate = new Date();

            // 根据参数决定是否调整日期 | 如果是结束时间，不需要加1
            const dayOffset = isStart ? offset - 1 : offset; // 如果是起始时间，偏移的天数需要加1
            currentDate.setDate(currentDate.getDate() - dayOffset);

            // 获取年、月、日
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，所以要加 1
            const day = String(currentDate.getDate()).padStart(2, '0');

            // 根据参数决定返回的时间格式
            return `${year}-${month}-${day} ${isStart ? '00:00:00' : '23:59:59'}`;
        },
        handleDataProcessed(isProcessed) {
            // 子组件触发的事件处理函数
            // 根据传递的信息来更新按钮的状态
            console.log("OeeQuerySpindle子组件执行完返回按钮解禁状态：" + isProcessed)
            this.disableButton = isProcessed; // 启用按钮
        },
        intervals() {
            this.refresh.everySecond = setInterval(() => {
                this.datetime = moment(new Date()).format(this.$t("em.datetime.format.viewMode"))
            }, 1000);

            this.refresh.everyHour = setInterval(() => {
                //this.getSafetyDate()

                console.clear();//clear logs every hour
            }, 3600 * 1000);

            this.refresh.atTwoClock = setInterval(() => {
                const now = new Date();
                if (now.getHours() === 12 && now.getMinutes() === 30 || now.getHours() === 18 && now.getMinutes() === 0) {
                    this.reloadPage();
                }
            }, 20000);
        },
        clearIntervals() {
            clearInterval(this.refresh.everySecond);
            clearInterval(this.refresh.everyHour);
            clearInterval(this.refresh.atTwoClock);
        },

        switchScreenFull() {
            screenfull.toggle();
            this.fnResize()
        },

        fnResize() {
            let deviceWidth = document.documentElement.clientWidth || window.innerWidth;
            document.documentElement.style.fontSize = (deviceWidth / 125) + 'px';
        },
        carousel(index) {
            this.currentWorkshop = index
        },
        reloadPage() {
            this.$emit('needReload');
        },
        formatShortDate(dateValue) {
            // 将日期时间字符串转换为 Date 对象
            if (dateValue === null || dateValue.trim() === '') {
                return null;
            }
            const date = new Date(dateValue);

            // 获取年、月、日部分
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 加1是因为月份从0开始，padStart用于补0
            const day = String(date.getDate()).padStart(2, '0');

            // 格式化为 'yyyy-MM-dd' 形式
            return `${year}-${month}-${day}`;
        },
        formatShortEndDate(dateValue) {
            // 将日期时间字符串转换为 Date 对象
            if (dateValue === null || dateValue.trim() === '') {
                return null;
            }
            const date = new Date(dateValue);

            // 获取年、月、日部分
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 加1是因为月份从0开始，padStart用于补0
            const day = String(date.getDate()).padStart(2, '0');

            // 格式化为 'yyyy-MM-dd' 形式
            return `至 ${year}-${month}-${day}`;
        },
        goBack() {
            // 退出全屏(尝试各种浏览器退出全屏)
            // 【注意】如果你使用F11键全屏，通过JavaScript 是无法退出的，因为浏览器限制了对于全屏模式的控制。用户通常需要手动按下F11键来退出全屏。
            // JavaScript的全屏API通常用于进入和退出由Web应用程序管理的全屏模式，而不是浏览器的F11全屏模式。
            // 所以，如果你的页面是使用F11键进入全屏的，你不能使用JavaScript来控制退出，这是浏览器的安全限制。
            if (screenfull.isFullscreen) {
                screenfull.exit();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }

            // 返回到上一页或者使用你的返回逻辑
            this.$router.push('/em?menuId=15752&pathType=');
        }
    }
}
</script>

<style scoped>
.bg {
    background-color: #1B1534;
    padding: 0.2rem 0.2rem 0 0.2rem;
    background-image: url("../../../../assets/images/emKpi/oeeBack4.jpg");
    background-size: cover;
    background-position: center center;
}

.dv-card-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


.w-100 >>> text {
    font-size: 1.6rem;
}


.dv-card-title.title-a {
    font-size: 1.2rem;
    color: white;
}

.decorative-text {
    font-size: 0.8rem;
    background-color: rgba(255, 255, 255, 0.1); /* 设置背景颜色为绿色 */
    color: white; /* 设置文字颜色为白色 */
    font-weight: bold; /* 设置文字为粗体 */
    border-radius: 10px; /* 设置圆角边框 */
    padding: 5px 15px; /* 设置内边距，根据需要调整 */
    display: inline-block; /* 使元素变成行内块级元素，以适应文本内容 */
    width: 100%;
    text-align: center;
    padding: 0.5rem 1rem;
}

.dashed-line {
    width: 100%; /* 设置元素宽度，可以根据需要调整 */
    height: 1px; /* 设置虚线的高度，可以根据需要调整 */
    background: transparent; /* 透明背景 */
    border-left: 1px dashed #CC66FF; /* 定义虚线样式和颜色 */
    border-width: 3px 5px; /* 第一个值是虚线间隔，第二个值是虚线长度 */
}

.return-button {
    font-size: 1rem;
    font-family: "宋体";
    background-color: #409eff; /* 设置按钮背景颜色 */
    color: #fff; /* 设置文字颜色 */
    padding: 10px 20px; /* 设置内边距 */
    text-decoration: none; /* 去掉下划线 */
    border-radius: 5px; /* 圆角 */
}

.return-button:hover {
    background-color: #66b1ff; /* 鼠标悬停时的颜色 */
    color: #ffffff; /* 设置文字颜色 */
}


/deep/ .el-input__inner {
    height: 2.5rem;
    font-size: 1rem;
}

/* 设置根元素的字体大小为基准大小 */
html {
    font-size: 16px;
}

/* 使用 flex 垂直居中 el-input 中的图标 */
/deep/ .el-input__suffix {
    display: flex;
    align-items: center;
}

/* 使用 flex 垂直居中 el-date-picker 中的图标 */
/deep/ .el-date-picker__icon {
    display: flex;
    align-items: center;
}

/deep/ .my-custom-button {
    /* 修改字体大小 */
    font-size: 1rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    /* 修改按钮宽度 */

}

/* 使用 rem 单位来指定开关的宽度和高度 */
.my-custom-switch {
    /* 修改宽度，假设 2rem 等于 32px（2倍基准大小） */
    width: 3rem;

    /* 修改高度，假设 1rem 等于 16px（基准大小） */
    height: 1rem;
}
</style>
